import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { Rates } from '../models/rates.model';

@Injectable({providedIn: 'root'})
export class RatesService {
  baseUrl = `${environment.apiUrl}`;
  simulateUrl = `${environment.apiUrlSimulate}`;
  simulatePath = 'simulate';
  siriUrl = `${environment.apiSiriUrl}`;


  constructor(
    private http: HttpClient,
    private router: Router,

  ) {}

  getTarifas(numempre: number, c_conces: number, codlinea: string ): Observable<Rates[]> {
    //TODO: PONER LA DIRECCION CORRECTA
    if (this.router.url.includes(this.simulatePath)){
      return this.http.get<Rates[]>(`https://localhost:44348/api/Tarifa/GetTarifasByLinea_sinPoblaciones?numempre=${numempre}&c_conces=${c_conces}&codlinea=${codlinea}`, {});
    } else {
      return this.http.get<Rates[]>(`https://localhost:44348/api/Tarifa/GetTarifasByLinea_sinPoblaciones?numempre=${numempre}&c_conces=${c_conces}&codlinea=${codlinea}`, {});
    }

  }

}
